import React, { Component } from "react";

export default class Education extends Component {
  render() {
    return (
      <section className="colorlib-services" data-section="skills">
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">What technologies do I use?</span>
              <h2 className="colorlib-heading">Some of my skills</h2>
            </div>
          </div>
          <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
              <div className="services color-1">
                <span className="icon">
                  <i className="icon-bulb"></i>
                </span>
                <div className="desc">
                  <h3>Java</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center animate-box">
              <div className="services color-2">
                <span className="icon">
                  <i className="icon-data"></i>
                </span>
                <div className="desc">
                  <h3>JavaScript</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center animate-box">
              <div className="services color-3">
                <span className="icon">
                  <i className="icon-phone3"></i>
                </span>
                <div className="desc">
                  <h3>ReactJS and Redux</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center animate-box">
              <div className="services color-4">
                <span className="icon">
                  <i className="icon-layers2"></i>
                </span>
                <div className="desc">
                  <h3>Docker</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center animate-box">
              <div className="services color-5">
                <span className="icon">
                  <i className="icon-data"></i>
                </span>
                <div className="desc">
                  <h3>SQL</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center animate-box">
              <div className="services color-6">
                <span className="icon">
                  <i className="icon-phone3"></i>
                </span>
                <div className="desc">
                  <h3>NodeJS</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
